<template>
  <div class="modal-mask">
      <div class="modal-container">
        <div class="modal-header">
          <header-logo
            class="header-logo"
            @click.native="$router.push('/')"/>
          <rare-modal-close-icon
            class="rareModalCloseIcon"
            @clicked="closeModal"
          />
        </div>

        <div id="standard-navigation" v-if="!isCandidatesSection">
          <div class="menu-item sub-nav-trigger">
            <router-link tag="span" to="/" id="product-link">Products</router-link>
            <span @click="showSubNavigation = !showSubNavigation" id="sub-nav-link">
              <img src="../../assets/img/icons/nav-arrow.svg"
                   class="nav-arrow"
                   :class="{ 'rotate-nav-arrow' : showSubNavigation }"
              />
            </span>
          </div>
          <div class="sub-nav-container" :class="{ 'sub-nav-container-open' : showSubNavigation }">
            <div class="spacer">&nbsp;</div>
            <div class="sub-nav-menu-item">
              <router-link tag="span" to="/products/crs">Contextual Recruitment System (CRS)</router-link>
            </div>
            <div class="sub-nav-menu-item">
              <router-link tag="span" to="/products/candid-ats">Candid ATS</router-link>
            </div>
            <div class="sub-nav-menu-item">
              <router-link tag="span" to="/products/hemisphere">Hemisphere</router-link>
            </div>
            <div class="sub-nav-menu-item">
              <router-link tag="span" to="/products/vantage">Vantage</router-link>
            </div>
            <div class="sub-nav-menu-item">
              <router-link tag="span" to="/products/attraction-and-development">Attraction & Development</router-link>
            </div>
            <div class="spacer">&nbsp;</div>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/research">Research</router-link>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/stories">Stories</router-link>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/about">About</router-link>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/candidates">Candidates</router-link>
          </div>
        </div>

        <div id="candidate-navigation" v-if="isCandidatesSection">
          <div class="menu-item">
            <router-link tag="span" to="/candidates">What we do</router-link>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/candidates/research">Research</router-link>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/candidates/stories">Stories</router-link>
          </div>
          <div class="menu-item">
            <router-link tag="span" to="/candidates/about">About</router-link>
          </div>
          <div class="menu-item">
            <rare-apply-now-button
              style="display: inline-block; padding-top: 9px; "
              :buttonText="'Apply now'"
              :active="'true'"
              :height="'40px'"
              @clicked="applyNow"/>
          </div>
        </div>

      </div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareModalCloseIconSmall from 'rare-patternlab/icons/navigation/RareModalCloseIconSmall';

import HeaderLogo from './HeaderLogo';

export default {
  name: 'navigationModal',
  components: {
    'header-logo': HeaderLogo,
    'rare-apply-now-button': RareStandardButton,
    'rare-modal-close-icon': RareModalCloseIconSmall,
  },
  data() {
    return {
      showSubNavigation: false,
    };
  },
  computed: {
    isCandidatesSection() {
      return this.$route.path.includes('candidates');
    },
  },

  methods: {
    closeModal() {
      this.$emit('closeNavigation');
    },
    applyNow() {
      this.$router.push('/candidates/apply-now');
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  created() {
    document.addEventListener('keyup', this.watchForEsc);
  },

  destroyed() {
    document.removeEventListener('keyup', this.watchForEsc);
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .modal-mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity .3s ease;
    background-color: $dark-grey-background;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    color: #ffffff;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    display:flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    width: 100%;
    border-bottom: 1px solid $mid-grey-background;
  }

  .rareModalCloseIcon {
    cursor: pointer;
    margin-right: 24px;
  }

  .header-logo {
    width: 100px;
    cursor: pointer;
    margin-left: 30px;
  }

  .nav-arrow {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -4px;
    margin-right: 30px;
    transform: rotate(180deg);
  }

  #standard-navigation, #candidate-navigation {
    width: 100%;
  }

  .rotate-nav-arrow {
    transform: rotate(0deg) !important;
  }

  #product-link {
    height: 100%;
    width: 20%;
    padding-top: 26px;
  }

  #sub-nav-link {
    height: 100%;
    display: block;
    width: 80%;
    position: relative;
  }

  .menu-item {
    cursor: pointer;
    height: 72px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid $mid-grey-background;
  }

  .menu-item span {
    display: block;
    margin-left: 26px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
  }

  .sub-nav-trigger {
    justify-content: space-between !important;
  }

  .sub-nav-container {
    width: 100%;
    background-color: #ffffff;
    transition: height 1s ease;
    height: 0;
  }

  .sub-nav-container-open {
    height: auto !important;
  }

  .sub-nav-menu-item {
    cursor: pointer;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .sub-nav-menu-item span {
    display: block;
    width: 100%;
    margin-left: 26px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #323C44;
  }

  .spacer {
    height: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/navigationModal.vue